import 'css-chunksrc/client/scenes/listRemoval/listsList/list/task/allocationsList/styles.scss';export default {
  "allocationsList": "_allocationsList_9ljc2_1",
  "list": "_list_9ljc2_5",
  "main": "_main_9ljc2_12",
  "allocation": "_allocation_9ljc2_1",
  "picture": "_picture_9ljc2_28",
  "summary": "_summary_9ljc2_34",
  "menu": "_menu_9ljc2_43",
  "addAllocationIcon": "_addAllocationIcon_9ljc2_47",
  "resourcesList": "_resourcesList_9ljc2_53",
  "up": "_up_9ljc2_60",
  "quickAllocationMenu": "_quickAllocationMenu_9ljc2_65",
  "overlay": "_overlay_9ljc2_70"
};